import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  WorkflowActionExecuteRequest,
  WorkflowActionExecuteResponse,
  WorkflowEmailPreviewRequest,
  WorkflowEmailPreviewResponse,
  WorkflowTokenRenderRequest,
  WorkflowTokenRenderResponse,
  WorkflowActionTestRequest,
  WorkflowActionTestResponse
} from '../models/workflow-action.model';

@Injectable({ providedIn: 'root' })
export class WorkflowActionApiService {
  private readonly apiUrl = `${environment.apiUrl}api/workflow-actions`;

  constructor(private http: HttpClient) {}

  executeCurrent(
    enrollmentId: number,
    request: WorkflowActionExecuteRequest = {}
  ): Observable<WorkflowActionExecuteResponse> {
    return this.http.post<WorkflowActionExecuteResponse>(
      `${this.apiUrl}/enrollments/${enrollmentId}/execute`, request
    );
  }

  executeNode(
    enrollmentId: number,
    nodeId: number,
    request: WorkflowActionExecuteRequest = {}
  ): Observable<WorkflowActionExecuteResponse> {
    return this.http.post<WorkflowActionExecuteResponse>(
      `${this.apiUrl}/enrollments/${enrollmentId}/execute-node/${nodeId}`, request
    );
  }

  previewEmail(request: WorkflowEmailPreviewRequest): Observable<WorkflowEmailPreviewResponse> {
    return this.http.post<WorkflowEmailPreviewResponse>(`${this.apiUrl}/preview-email`, request);
  }

  renderTokens(request: WorkflowTokenRenderRequest): Observable<WorkflowTokenRenderResponse> {
    return this.http.post<WorkflowTokenRenderResponse>(`${this.apiUrl}/render-tokens`, request);
  }

  testAction(request: WorkflowActionTestRequest): Observable<WorkflowActionTestResponse> {
    return this.http.post<WorkflowActionTestResponse>(`${this.apiUrl}/test`, request);
  }
}
